import { 
	ADD_BRANCH,
	ADD_BRANCH_ERROR,
	ADD_BRANCH_SUCCESS,
	ADD_COMPLETION_TIME,
	ADD_COMPLETION_TIME_ERROR,
	ADD_COMPLETION_TIME_SUCCESS,
	ADD_LANGUAGE,
	ADD_LANGUAGE_ERROR,
	ADD_LANGUAGE_SUCCESS,
	ADD_SERVICE, 
	ADD_SERVICE_ERROR, 
	ADD_SERVICE_SUCCESS, 
	ADD_WORD, 
	ADD_WORD_ERROR, 
	ADD_WORD_SUCCESS, 
	DELETE_SERVICE, 
	DELETE_SERVICE_ERROR, 
	DELETE_SERVICE_SUCCESS, 
	EDIT_BRANCH, 
	EDIT_BRANCH_ERROR, 
	EDIT_BRANCH_SUCCESS, 
	EDIT_COMPLETION_TIME, 
	EDIT_COMPLETION_TIME_ERROR, 
	EDIT_COMPLETION_TIME_SUCCESS, 
	EDIT_LANGUAGE, 
	EDIT_LANGUAGE_ERROR, 
	EDIT_LANGUAGE_SUCCESS, 
	EDIT_SERVICE, 
	EDIT_SERVICE_ERROR, 
	EDIT_SERVICE_SUCCESS, 
	EDIT_WORD, 
	EDIT_WORD_ERROR, 
	EDIT_WORD_SUCCESS, 
	GET_ANNUAL_STATISTICS, 
	GET_ANNUAL_STATISTICS_ERROR, 
	GET_ANNUAL_STATISTICS_SUCCESS, 
	GET_BRANCHS, 
	GET_BRANCHS_ERROR, 
	GET_BRANCHS_SUCCESS, 
	GET_COMPLETION_TIMES, 
	GET_COMPLETION_TIMES_ERROR, 
	GET_COMPLETION_TIMES_SUCCESS, 
	GET_LANGUAGES, 
	GET_LANGUAGES_ERROR, 
	GET_LANGUAGES_SUCCESS, 
	GET_SERVICES, 
	GET_SERVICES_ERROR, 
	GET_SERVICES_SUCCESS, 
	GET_VIEWS, 
	GET_VIEWS_ERROR, 
	GET_VIEWS_SUCCESS, 
	GET_WORDS,
	GET_WORDS_ERROR,
	GET_WORDS_SUCCESS
  } from "redux/constants/Settings";

const initState = {
	loading: false,
	services: [],
	branchs: [],
	completionTimes: [],
	languages: [],
	words: [],
	views: [],
	annualStatistics: {
		data: [],
		monthlyTarget: -1
	},
	message: '',
}

const settings = (state = initState, action) => {
	switch (action.type) {
		case GET_SERVICES:
			return {
				...state,
				loading: true,
				services: []
			}
		case GET_SERVICES_SUCCESS:
			return {
				...state,
				loading: false,
				services: action.services
			}
		case GET_SERVICES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_SERVICE:
			return {
				...state,
				loading: true,
			}
		case ADD_SERVICE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_SERVICE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_SERVICE:
			return {
				...state,
				loading: true,
			}
		case EDIT_SERVICE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_SERVICE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case DELETE_SERVICE:
			return {
				...state,
				loading: true,
			}
		case DELETE_SERVICE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case DELETE_SERVICE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_BRANCHS:
			return {
				...state,
				loading: true,
				branchs: []
			}
		case GET_BRANCHS_SUCCESS:
			return {
				...state,
				loading: false,
				branchs: action.branchs
			}
		case GET_BRANCHS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_BRANCH:
			return {
				...state,
				loading: true,
			}
		case ADD_BRANCH_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_BRANCH_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_BRANCH:
			return {
				...state,
				loading: true,
			}
		case EDIT_BRANCH_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_BRANCH_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_LANGUAGES:
			return {
				...state,
				loading: true,
				languages: []
			}
		case GET_LANGUAGES_SUCCESS:
			return {
				...state,
				loading: false,
				languages: action.languages
			}
		case GET_LANGUAGES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_LANGUAGE:
			return {
				...state,
				loading: true,
			}
		case ADD_LANGUAGE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_LANGUAGE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_LANGUAGE:
			return {
				...state,
				loading: true,
			}
		case EDIT_LANGUAGE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_LANGUAGE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_COMPLETION_TIMES:
			return {
				...state,
				loading: true,
				languages: []
			}
		case GET_COMPLETION_TIMES_SUCCESS:
			return {
				...state,
				loading: false,
				completionTimes: action.completionTimes
			}
		case GET_COMPLETION_TIMES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_COMPLETION_TIME:
			return {
				...state,
				loading: true,
			}
		case ADD_COMPLETION_TIME_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_COMPLETION_TIME_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_COMPLETION_TIME:
			return {
				...state,
				loading: true,
			}
		case EDIT_COMPLETION_TIME_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_COMPLETION_TIME_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_WORDS:
			return {
				...state,
				loading: true,
				words: []
			}
		case GET_WORDS_SUCCESS:
			return {
				...state,
				loading: false,
				words: action.words
			}
		case GET_WORDS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_WORD:
			return {
				...state,
				loading: true,
			}
		case ADD_WORD_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_WORD_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_WORD:
			return {
				...state,
				loading: true,
			}
		case EDIT_WORD_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_WORD_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_VIEWS:
			return {
				...state,
				loading: true,
			}
		case GET_VIEWS_SUCCESS:
			return {
				...state,
				loading: false,
				views: action.views
			}
		case GET_VIEWS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_ANNUAL_STATISTICS:
			return {
				...state,
				loading: true,
				annualStatistics: {
					data: [],
					monthlyTarget: -1
				}
			}
		case GET_ANNUAL_STATISTICS_SUCCESS:
			return {
				...state,
				loading: false,
				annualStatistics: action.annualStatistics
			}
		case GET_ANNUAL_STATISTICS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		default:
			return state;
	}
}

export default settings